import React, { Component } from 'react';
import banner1 from './images/product-service-banner1.jpg';
import banner2 from './images/product-service-banner2.jpg';
import freightSystemImg from './images/freight-system-img.png';
import matchSystem from './images/match-system.png';
import creditSystem from './images/credit-system.png';
import Slider from "react-slick";
var bannerBg1 = {
  background: 'url(' + banner1 + ') center no-repeat',
  height:'600px'
}

var bannerBg2 = {
  background: 'url(' + banner2 + ') center no-repeat',
  height:'600px'
}

class ProductService extends Component {
  componentDidMount(){
    window.scrollTo(0,0);
  }
  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 600,
      autoplay:true,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div className="productService">
        <Slider {...settings}>
          <div>
            <div style={bannerBg1}>
                <div className='max-width-box'>
                    <div className='banner-content'>
                      <h3>货运交易系统</h3>
                      <h3>货代拖车系统</h3>
                    </div>
                </div>
              </div>
          </div>
          <div>
            <div style={bannerBg2}>
                <div className='max-width-box'>
                   <div className='banner-content'>
                      <h3>老板、货主、司机</h3>
                      <h3>夏老师App...</h3>
                    </div>
                </div>
              </div>
          </div>
        </Slider>
        <div className="product-title">
          <div className='max-width-box'>
            <div className='title'>
              <h3>产品三大优势</h3>
              <span></span>
            </div>
          </div>
        </div>
        <div className='freight-system'>
            <div className='max-width-box'>
                <div className='flex-box'>
                  <div className='freight-system-left'>
                    <div className='product-item-title'>
                      <h3>货代拖车系统</h3>
                      <span className='line'></span>
                    </div>
                      <p>“一站式”全业务员流程管理!为上下游每个环节制定PC端系统或手机APP;业务全程可视，货物在哪轻松查看！上下游数据智能交互，精准高效！</p>
                  </div>
                  <div className='freight-system-right'>
                      <img src={freightSystemImg} width='720' height='626' alt='货代拖车系统'/>
                  </div>
                </div>
            </div>
        </div>

        <div className='match-system'>
            <div className='max-width-box'>
                <div className='flex-box'>
                  <div className='match-system-left'>
                      <img src={matchSystem} width='647' height='609' alt='货运交易平台-车货匹配'/>
                  </div>
                  <div className='match-system-right'>
                      <div className='product-item-title'>
                         <h3>货运交易平台-车货匹配</h3>
                         <span className='line' style={{background: '#e9e9e9'}}></span>
                      </div>
                      <p>重出重回，财源滚滚!汇集国内集装箱运输大量货源、运力；货运运力严格验证，安全可靠！货运交易平台搭载手机APP，实现车与货精准匹配！</p>
                  </div>
                </div>
            </div>
        </div>
        <div className='credit-system'>
            <div className='max-width-box'>
                <div className='flex-box'>
                  <div className='credit-system-left'>
                      <div className='product-item-title'>
                         <h3>信用评价体系</h3>
                         <span className='line'></span>
                      </div>
                      <p>构建内贸集运行业权威信用评价体系！根据客户互评、大数据分析，形成评级体系；根据推荐评级选择合作客户，消灭行业不诚信行为！为每个角色建立信用评级，选择优质供应商提供参考，提升企业服务水平！</p>
                  </div>
                  <div className='credit-system-right'>
                      <img src={creditSystem} width='518' height='525' alt='信用评价体系'/>
                  </div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default ProductService;



// WEBPACK FOOTER //
// ./src/pages/productService/index.js